import { FC, useState } from 'react';
import { useSelector } from 'react-redux';

// components
import { Link } from 'dibs-elements/exports/Link';
import { FormattedMessage } from 'dibs-react-intl';
import { BidHistoryModalLazy } from 'dibs-auctions/exports/BidHistoryModalLazy';

// styles
import styles from './PdpSharedAuctionViewHistory.scss';

type Props = {
    currency: string;
};

type RelayVariables = {
    isClient: boolean;
    itemId: string;
};

type ReduxStoreType = {
    relayVariables: {
        variables: RelayVariables;
    };
};

export const PdpSharedAuctionViewHistory: FC<Props> = ({ currency }) => {
    const [isBidModalOpen, setIsBidModalOpen] = useState<boolean>(false);
    const { isClient, itemId } = useSelector<ReduxStoreType, RelayVariables>(
        relay => relay?.relayVariables?.variables || {}
    );

    if (!itemId || !isClient) {
        return null;
    }

    return (
        <div className={styles.container}>
            <Link onClick={() => setIsBidModalOpen(true)}>
                <FormattedMessage
                    id="PdpSharedAuctionClosed.viewBiddingHistory"
                    defaultMessage="View Bidding History"
                />
            </Link>
            <BidHistoryModalLazy
                page="pdp"
                itemId={itemId}
                isClient={isClient}
                currency={currency}
                isOpen={isBidModalOpen}
                onClose={() => setIsBidModalOpen(false)}
            />
        </div>
    );
};
